
<button mat-icon-button (click)="toggleSidenav()">
    <mat-icon [svgIcon]="'heroicons_outline:question-mark-circle'"></mat-icon>
</button>

<div class="sidenav" [class.open]="opened">
    <div class="sidenav-header-container">
        <div class="sidenav-header">
            <p>{{"help.title" | transloco}}</p>
            <button
                class=" "
                mat-icon-button
                (click)="close()">
                <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
    </div>
    <div class="sidenav-body-container">
        <div class="sidenav-body" >
            <div class="title">
                <strong> {{data?.title || ''}} </strong>
            </div> 
            <div class="content-container">
                <div class="content" [innerHTML]="data?.content"></div>
            </div>           
        </div> 
        <div class="sidenav-footer" *ngIf="drakeChatBot">
            <div class="chatbot-div">
                <button class="chatbot-button"
                (click)="openChatBot()">
                <img src="assets/images/icons/chatbot.png" alt="Chatbot" />
                </button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showChatBot && !opened" class="chatbot-container" [class.visible]="showChatBot">
        <div class="sidenav-header-container" >
          <div class="sidenav-header">
              <p>DrakeBot</p>
              <button
                  class=" "
                  mat-icon-button
                  (click)="closeChatBot()">
                  <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
              </button>
          </div>
        </div>
        <div ><!--class="sidenav-body-container"-->
            <div class="sidenav-body" > 
                <app-drake-bot *ngIf="showChatBot"></app-drake-bot>
            </div>
        </div>
</div>